// Headless export registration for the Word Cloud chart.
// SVG-based (CloudSVG) — the hook serializes the chart's own <svg> ref through
// svgToPngDataUrl. Chart-type key `wc` is the legacy chartMode/viewMode key
// (Option A). The live WordCloud component is reused as-is — no duplicate.
// Spec: .aidev/tasks/headless-charts-sdk-spike/docs/tasks/04-wc.md §4.2

import { ExportableCharts } from '@aytm/app/stats/page/question-views/components/charts/lib/exportable'
import { applyPreset } from '@aytm/app/stats/page/question-views/components/word-cloud/utils/applyPreset'

import WordCloudChart from '@aytm/app/stats/page/question-views/components/word-cloud/Chart'

ExportableCharts.register('wc', {
  Component: WordCloudChart,
  toProps: (data: any, params: any) => ({
    // Layout depends on dimensions — driver supplies them, defaults otherwise.
    width: params.width || 800,
    height: params.height || 600,
    model: data.model,
    words: data.words,
    // A preset token in the config stands in for the look it owns; the page shell that would
    // normally resolve it is not loaded here.
    config: applyPreset(data.config || {}, data.words?.length || 0),
    scope: data.scope || [],
    disabled: false,
    // Interactive callbacks stay undefined in headless.
    onParamsChange: undefined,
    onWordClick: undefined
  })
})
